<template>
	<div id="fiveStars">
		<p>到场时间：<img v-for="(star,index) in stars.list" :src="star.src" @click="rating(index, stars)"  /></p>
		<p>专业水平：<img v-for="(star,index) in stars1.list" :src="star.src" @click="ratingLevel(index, stars1)"  /></p>
		<p>服务态度：<img v-for="(star,index) in stars2.list" :src="star.src" @click="ratingAttitude(index, stars2)"  /></p>
	</div>
</template>

<script>
		//黑星星的路径
   const starOff ='../../../static/img/wjx-old.png';
	//亮星星的路径
	const starOn='../../../static/img/wjx-new.png';

	export default{
		name:'fiveStars',
		// props: ['starsAll'],
    data(){
		  return {
          stars: {
            list: [
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
            ],
            starNum:0
          },
          stars1:{
            list: [
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
            ],
            starNum:0
          },
          stars2:{
            list: [
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
              {src:starOff,active:false},
            ],
            starNum:0 //点击星星的次数
        },
      }
    },
		methods:{
      rating(index, stars){
        let total = stars.list.length;//星星总数
        let idx = index + 1//代表应该显示的星星的数量
        if(stars.starNum ==0){  //只点了一个星星
          stars.starNum =idx
          for(var i=0;i<idx;i++){
            stars.list[i].src=starOn;
            stars.list[i].active=true;
          }
        }else{
          //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
          if(idx == stars.starNum){
            for(var i=idx;i<total;i++){
              stars.list[i].src=starOff;
              stars.list[i].active=false;
            }
          }
          //如果小于当前最高星级，则直接保留当前星级
          if(idx <stars.starNum){
            for(var i=idx;i<stars.starNum;i++){
              stars.list[i].src=starOff;
              stars.list[i].active=false;
            }
          }
          //如果大于当前星级，则直接选到该星级
          if(idx > stars.starNum){
            for(var i=0;i<idx;i++){
              stars.list[i].src=starOn;
              stars.list[i].active=true;
            }
          }
          let count =0;//当前几颗星
          for(var i=0;i<total;i++){
            if(stars.list[i].active){
              count++;
            }
          }
          stars.starNum =count;
          console.log(stars.starNum)
        }
      },
			// rating(index,stars){
			// 	this.$emit('rating',index,stars)
			// 	this.$emit('ratingLevel',index,stars)
			// 	this.$emit('ratingAttitude',index,stars)
			// }
		}
	}
</script>

<style scoped lang="less">
	#fiveStars{
		p{
			font-size:30px;
			text-align: left;
			line-height: 60px;
			img{
				width:40px;
				margin-right: 10px;
				vertical-align: middle;
			}
		};
	}
</style>



// WEBPACK FOOTER //
// src/components/son/fiveStars.vue